export default __webpack_public_path__ + "static/media/icon-aviso-modal.e7cf5124.svg";